import React, {useState} from 'react';
import {useAuth} from '../../context/AuthContext.tsx';
import {useAuthApi} from '../../context/ApiContext.tsx';
import {NotificationType, useNotification} from "../../context/NotificationContext.tsx";

export const BackdoorLogin = () => {
    const [username, setUsername] = useState('');
    const { setMe} = useAuth();
    const {showNotification} = useNotification();
    const authApi = useAuthApi();
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        setIsLoading(true);
        authApi.backdoor({username})
            .then((response) => {
                setMe(response);
                showNotification(NotificationType.SUCCESS, `Logged in as ${response.userType}`);
            })
            .catch(() => {
                showNotification(NotificationType.ERROR, 'Login failed. Please check your credentials.');
            })
            .finally(() => setIsLoading(false));

    };

    return (
        <div className="h-screen flex flex-col items-center justify-start bg-cover bg-center bg-no-repeat">
            {/* Overlay to ensure text readability */}
            <div className="absolute inset-0 bg-black/40"/>

            {/* Content - Using h-screen and sized to fit iPhone SE */}
            <div className="relative z-10 w-full max-w-md px-2 sm:px-4 h-full py-2 flex flex-col justify-between">

                {/* Login Card - Perfectly sized for iPhone SE */}
                <div
                    className="bg-white/95 backdrop-blur-sm rounded-xl sm:rounded-2xl shadow-xl sm:shadow-2xl p-3 sm:p-8 mx-auto w-full">
                    <div className="mb-2 sm:mb-6 text-center">
                        <h1 className="text-lg sm:text-2xl font-bold text-blue-800">Sign In As Appraiser</h1>
                        <p className="text-xs sm:text-sm text-gray-600">Please enter appraiser credentials</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-6">
                        <div>
                            <label htmlFor="username"
                                   className="block mb-1 text-xs sm:text-sm font-medium text-gray-700">
                                Username
                            </label>
                            <input
                                id="username"
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                className="w-full px-2 py-1.5 border border-gray-300 rounded-md
                                         focus:outline-none focus:ring-1 focus:ring-blue-500
                                         focus:border-blue-500 text-xs sm:text-sm"
                                placeholder="Enter Appraiser username"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full py-1.5 sm:py-2.5 bg-blue-600 text-white text-xs sm:text-sm font-medium
                                     rounded-md hover:bg-blue-700 focus:outline-none
                                     focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                                     disabled:opacity-50 disabled:cursor-not-allowed
                                     flex items-center justify-center"
                        >
                            {isLoading ? (
                                <>
                                    <div
                                        className="mr-1.5 h-3 w-3 sm:h-4 sm:w-4 border-2 border-white border-t-transparent rounded-full animate-spin"/>
                                    Signing in...
                                </>
                            ) : (
                                'Sign in'
                            )}
                        </button>
                    </form>
                </div>

                {/* Footer with some spacing at the bottom */}
                <div className="py-2 text-center text-white/80 text-xs">
                    © {new Date().getFullYear()} Stewart Valuation Intelligence
                </div>
            </div>
        </div>
    );
};